import type { FaireProductEntity } from "../../entity_types/product";

export const p_yfygegf83n: FaireProductEntity = {
  token: "p_yfygegf83n",
  type: "product",
  name: "Sedona Bison Skull Crewneck Sweatshirt",
  brandToken: "b_fdmfz6yamg",
  brandName: "Vortex Visions Design",
  imageUrl: "https://cdn.faire.com/fastly/8e04f5038db395b4a6cf4d0ab9f5496430ef5968b90c8e86ace1faf69d83f5fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9006ae61f90a2a4f4afd3ae6d9f57883548784020642668fe791d2ff8cda24fe.png",
    "https://cdn.faire.com/fastly/a0b1aa0e92efb4c2bf17af971834fbe2de7994596f6fd877f28061e4e18070a7.png",
    "https://cdn.faire.com/fastly/644de4d91127eed74eba85bf7fa19b2cbf7d6132a823f5418530dafdab8d4dce.png"
  ],
  priceDollars: 47.11,
  description: "Introducing the \"Sedona Bison Skull\" Crewneck Sweatshirt—a unisex fit that exudes Southwestern charm and bold design. Its iconic bison skull artwork captures the rugged beauty of the Southwest. Crafted for comfort and style, this tee adapts effortlessly to any wardrobe. Whether you're exploring the outdoors or enjoying an urban setting, this sweatshirt offers both a bold fashion statement and lasting durability. Celebrate the untamed spirit of the American West with this distinctive and versatile \n",
  tags: [],
  msrpDollars: 94.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:08.159Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
